export default function RichText({ children }: { children: React.ReactNode }) {
  return children;
}